import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectAccessToken,
  selectRegisterStep,
  selectRole,
  selectUserData,
} from 'routing/fetchingfunction/user/user.reducer'
import { TUTOR_ROLE } from 'constants'
import { getUser, logout, setStep, switchRole } from 'routing/fetchingfunction/user/user.action'
import { Button } from 'components/UI'
import { BACKEND_REGISTRATION_CODES } from 'constants'

const BufferPage = ({ role = 'tutor' }) => {
  const [loading, setLoading] = useState()
  const dispatch = useDispatch()
  const [showConfetti, setShowConfetti] = useState(true)
  const navigate = useNavigate()

  const registerRole = useSelector(selectRole)
  const accessToken = useSelector(selectAccessToken)
  const registerStep = useSelector(selectRegisterStep)

  const handleClick = () => {
    if (registerRole !== role) {
      // Dispatch switchRole and wait for it to complete before navigating
      dispatch(switchRole(role))
        .unwrap()
        .then((result) => {
          console.log(`Role switched to ${role}, now navigating to dashboard`)
          // Navigation will happen automatically through the Link's to prop
        })
        .catch((error) => {
          console.error('Error switching roles:', error)
        })
    }

    // Don't reset registration step after completion
    // This allows users to properly navigate after completing registration
    console.log('Registration complete, keeping COMPLETED status')
  }

  console.log(role)

  const handleExitRegistration = async () => {
    try {
      // Dispatch logout and wait for it to complete
      await dispatch(logout()).unwrap()
      //console.log('Logout completed, redirecting to homepage')

      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('Logout completed, redirecting to homepage')
      }

      // Only navigate after logout is complete
      navigate('/')
    } catch (error) {
      console.error('Error during logout:', error)
      // Still try to navigate to homepage even if logout fails
      navigate('/')
    }
  }

  useEffect(() => {
    if (accessToken) {
      dispatch(getUser())
    }

    // Automatically hide confetti after some time to improve performance
    const timer = setTimeout(() => {
      setShowConfetti(false)
    }, 15000)

    return () => clearTimeout(timer)
  }, [dispatch, accessToken])

  return (
    <div className="bg-[#FEEBDD] rounded-lg py-16 px-6 sm:px-10 md:px-20 lg:px-32 xl:px-36 text-[#F67443] max-w-4xl w-full mx-auto my-16 flex flex-col items-center justify-start relative overflow-hidden">
      <h3 className="text-2xl sm:text-3xl font-semibold mb-20 z-20 text-center">
        Thanks for registering with Apolo!{' '}
      </h3>
      <div className="mb-[79px] glowing w-[200px] h-[200px] rounded-full overflow-hidden bg-transparent z-20">
        <img
          className="block w-full h-full object-contain mix-blend-multiply"
          src="/assets/image/trophy.gif"
          alt="trophy"
          style={{
            objectFit: 'contain',
            background: 'transparent',
            filter: 'drop-shadow(0px 0px 8px rgba(0,0,0,0.1))',
          }}
        />
      </div>
      <p className="text-lg font-semibold text-center tracking-wide leading-8 mb-4">
        You’re officially registered as a member, and we couldn’t be more excited. Our team is
        working hard behind the scenes to build a platform that empowers your learning and teaching
        journey. We’ll let you know as soon as we launch. Your Apolo journey is just around the
        corner.
      </p>

      <div className="w-full max-w-xl m-auto">
        <Button
          loading={loading}
          text={'Exit Registration'}
          onClick={handleExitRegistration}
          className="!w-full !text-base mb-4 py-2 px-6 font-medium shadow hover:bg-indigo-700 transition bg-primary-75 text-white"
        >
          Logout
        </Button>{' '}
        {role === TUTOR_ROLE && (
          <Button
            loading={loading}
            onClick={() => {
              dispatch(
                setStep({
                  step: BACKEND_REGISTRATION_CODES.COMPLETED,
                  skipBackendUpdate: true,
                })
              )
              navigate(`/${role}/register/pass-test?test-step=7&status=completed`, {
                replace: true,
              })
            }}
            className="w-full !text-base py-2 px-6 font-medium shadow hover:bg-indigo-700 transition border !border-primary-100 !text-primary-75 bg-white"
          >
            Take Another Test
          </Button>
        )}
      </div>
    </div>
  )
}

export default BufferPage
